import { render } from "./WeChatCallbackView.vue?vue&type=template&id=744a7809&scoped=true"
import script from "./WeChatCallbackView.vue?vue&type=script&lang=js"
export * from "./WeChatCallbackView.vue?vue&type=script&lang=js"

import "./WeChatCallbackView.vue?vue&type=style&index=0&id=744a7809&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744a7809"]])

export default __exports__